module.exports = __webpack_public_path__ + "static/media/follow.4dce774d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/follow.svg
// module id = 904
// module chunks = 1